// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editorWrapper__cQydx {
  position: relative;
}
.editorWrapper__cQydx.simple__v6JnI .tox.tox-tinymce {
  border: 1px solid #c7cddd;
  border-radius: 2px;
}
.editorWrapper__cQydx .tox-editor-container .tox-statusbar__branding {
  display: none !important;
}
.editorWrapper__cQydx .tox .tox-toolbar-overlord {
  height: 35px !important;
}
.editorWrapper__cQydx .tox-editor-header {
  height: 34px;
  padding: 0 !important;
  box-shadow: none !important;
  background-color: var(--inputs-disable-disable-surface) !important;
  border-bottom: 1px solid var(--inputs-filled-stroke) !important;
}
.editorWrapper__cQydx .tox .tox-toolbar,
.editorWrapper__cQydx .tox .tox-toolbar__overflow,
.editorWrapper__cQydx .tox .tox-toolbar__primary {
  background-color: var(--inputs-disable-disable-surface) !important;
  border-bottom: 1px solid var(--inputs-filled-stroke) !important;
  background-image: none;
}
.editorWrapper__cQydx .tox .tox-toolbar-overlord .tox-toolbar:not(.tox-toolbar--scrolling):first-child,
.editorWrapper__cQydx .tox .tox-toolbar-overlord .tox-toolbar__primary {
  background-position: center top 34px;
}
.editorWrapper__cQydx .tox .tox-tbtn svg {
  fill: var(--inputs-default-icon);
}
.editorWrapper__cQydx .tox-dialog__footer-end .tox .tox-button {
  border: none;
  color: #ffffff !important;
  background-color: #3c97aa !important;
}
.editorWrapper__cQydx .tox-edit-area__iframe {
  font-family: "Roboto", sans-serif !important;
  background-color: var(--inputs-filled-filled-surface);
}
.editorWrapper__cQydx .tox .tox-label {
  font-family: "Roboto", sans-serif !important;
}
.editorWrapper__cQydx .tox .tox-button--naked {
  cursor: pointer;
}
.editorWrapper__cQydx .tox .tox-button--naked:hover:not(:disabled) {
  background-color: transparent;
}
.editorWrapper__cQydx .tox .tox-menu {
  background-color: var(--inputs-filled-filled-surface) !important;
}
.editorWrapper__cQydx .tox .tox-tbtn--select {
  color: var(--inputs-default-icon);
}
.editorWrapper__cQydx .tox .tox-dialog__title {
  font-family: "Roboto", sans-serif !important;
}
.editorWrapper__cQydx .tox .tox-dialog {
  border-radius: 0 !important;
}
.editorWrapper__cQydx .tox .tox-dialog__header {
  padding: 8px 16px 10px 16px;
}
.editorWrapper__cQydx .tox .tox-dialog__header::before {
  content: "";
  width: 100%;
  height: 1px;
  background-color: #ececec;
  position: absolute;
  left: 0;
  bottom: 0;
}
.editorWrapper__cQydx .tox .tox-dialog__header:after {
  content: "";
  width: 42px;
  height: 3px;
  background-color: #fcc201;
  position: absolute;
  left: 0;
  bottom: -1.5px;
}
.editorWrapper__cQydx .tox .tox-dialog__footer {
  padding: 16px;
}
.editorWrapper__cQydx .tox .tox-dialog__footer .tox-button {
  width: 100px;
  border: none;
  color: #ffffff !important;
  background-color: #3c97aa !important;
  font-family: "Roboto", sans-serif !important;
  border-radius: 0 !important;
  font-weight: 400;
  text-transform: uppercase;
  cursor: pointer;
}
.editorWrapper__cQydx .tox .tox-dialog__footer .tox-button[title]:hover:after {
  content: attr(text);
}
.editorWrapper__cQydx .tox .tox-dialog__footer .tox-button--secondary {
  background-color: transparent !important;
  color: #3c97aa !important;
}
.editorWrapper__cQydx .tox-textfield {
  font-size: 12px;
  line-height: 20px;
  color: #000000;
  font-family: "Roboto", sans-serif !important;
  outline: 0;
}
.editorWrapper__cQydx .tox .tox-custom-editor:focus-within,
.editorWrapper__cQydx .tox .tox-listboxfield .tox-listbox--select:focus,
.editorWrapper__cQydx .tox .tox-textarea-wrap:focus-within,
.editorWrapper__cQydx .tox .tox-textarea:focus,
.editorWrapper__cQydx .tox .tox-textfield:focus {
  background-color: #fff !important;
  border-color: #3c97aa !important;
  box-shadow: none !important;
}
.editorWrapper__cQydx .tox .tox-dialog__body-nav-item--active {
  border-bottom: 2px solid #3c97aa !important;
  color: #3c97aa !important;
}
.editorWrapper__cQydx .tox-edit-area p img {
  max-width: 200px !important;
  width: 100% !important;
  height: auto;
}
.editorWrapper__cQydx iframe img {
  max-width: 200px !important;
  width: 100% !important;
  height: auto;
}
.editorWrapper__cQydx .tox-editor-header.tox-editor-header--empty {
  display: none;
}
.editorWrapper__cQydx .tox .tox-tab {
  display: none !important;
}
.editorWrapper__cQydx .tox.tox-tinymce {
  border: 1px solid var(--inputs-filled-stroke);
}
.editorWrapper__cQydx .tox.tox-tinymce.tox-platform-touch {
  -webkit-overflow-scrolling: touch !important;
  overflow-y: scroll;
}

.tox.tox-tinymce-aux {
  z-index: 1501;
}

.loaderWrapper__R6kvI {
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  background-color: rgba(0, 0, 0, 0.15);
}

.loaderWrapperSimple__JnjwM {
  top: 0;
}

.loader__CvX4Y {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.loader__CvX4Y > img {
  width: 50px;
  height: 50px;
}`, "",{"version":3,"sources":["webpack://./../src/components/common/Editor/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,kBAAA;AAzEF;AA6EM;EACE,yBAAA;EACA,kBAAA;AA3ER;AAiFM;EACE,wBAAA;AA/ER;AAmFI;EACE,uBAAA;AAjFN;AAmFI;EACE,YAAA;EACA,qBAAA;EACA,2BAAA;EACA,kEAAA;EACA,+DAAA;AAjFN;AAmFI;;;EAGE,kEAAA;EACA,+DAAA;EACA,sBAAA;AAjFN;AAmFI;;EAEE,oCAAA;AAjFN;AAmFI;EACE,gCAAA;AAjFN;AAoFI;EACE,YAAA;EACA,yBAAA;EACA,oCAAA;AAlFN;AAoFI;EACE,4CAAA;EACA,qDAAA;AAlFN;AAsFM;EACE,4CAAA;AApFR;AAsFM;EACE,eAAA;AApFR;AAqFQ;EACE,6BAAA;AAnFV;AAsFM;EACE,gEAAA;AApFR;AAsFM;EACE,iCAAA;AApFR;AAuFM;EACE,4CAAA;AArFR;AAuFM;EACE,2BAAA;AArFR;AAuFM;EACE,2BAAA;AArFR;AAsFQ;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;AApFV;AAsFQ;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,OAAA;EACA,cAAA;AApFV;AAuFM;EACE,aAAA;AArFR;AAsFQ;EACE,YAAA;EACA,YAAA;EACA,yBAAA;EACA,oCAAA;EACA,4CAAA;EACA,2BAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;AApFV;AAsFQ;EACE,mBAAA;AApFV;AAsFQ;EACE,wCAAA;EACA,yBAAA;AApFV;AAyFI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,4CAAA;EACA,UAAA;AAvFN;AAyFI;;;;;EAKE,iCAAA;EACA,gCAAA;EACA,2BAAA;AAvFN;AA0FI;EACE,2CAAA;EACA,yBAAA;AAxFN;AA2FI;EACE,2BAAA;EACA,sBAAA;EACA,YAAA;AAzFN;AA4FI;EACE,2BAAA;EACA,sBAAA;EACA,YAAA;AA1FN;AA6FI;EACE,aAAA;AA3FN;AA8FI;EACE,wBAAA;AA5FN;AA+FI;EACE,6CAAA;AA7FN;AAgGI;EACE,4CAAA;EACA,kBAAA;AA9FN;;AAoGE;EACE,aAAA;AAjGJ;;AAqGA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,qCAAA;AAlGF;;AAqGA;EACE,MAAA;AAlGF;;AAqGA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAlGF;AAoGE;EACE,WAAA;EACA,YAAA;AAlGJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.editorWrapper {\n  position: relative;\n\n  &.simple {\n    :global {\n      .tox.tox-tinymce {\n        border: 1px solid #c7cddd;\n        border-radius: 2px;\n      }\n    }\n  }\n  :global {\n    .tox-editor-container {\n      .tox-statusbar__branding {\n        display: none !important;\n      }\n    }\n\n    .tox .tox-toolbar-overlord {\n      height: 35px !important;\n    }\n    .tox-editor-header {\n      height: 34px;\n      padding: 0 !important;\n      box-shadow: none !important;\n      background-color: var(--inputs-disable-disable-surface) !important;\n      border-bottom: 1px solid var(--inputs-filled-stroke) !important;\n    }\n    .tox .tox-toolbar,\n    .tox .tox-toolbar__overflow,\n    .tox .tox-toolbar__primary {\n      background-color: var(--inputs-disable-disable-surface) !important;\n      border-bottom: 1px solid var(--inputs-filled-stroke) !important;\n      background-image: none;\n    }\n    .tox .tox-toolbar-overlord .tox-toolbar:not(.tox-toolbar--scrolling):first-child,\n    .tox .tox-toolbar-overlord .tox-toolbar__primary {\n      background-position: center top 34px;\n    }\n    .tox .tox-tbtn svg {\n      fill: var(--inputs-default-icon);\n    }\n\n    .tox-dialog__footer-end .tox .tox-button {\n      border: none;\n      color: #ffffff !important;\n      background-color: #3c97aa !important;\n    }\n    .tox-edit-area__iframe {\n      font-family: 'Roboto', sans-serif !important;\n      background-color: var(--inputs-filled-filled-surface);\n    }\n\n    .tox {\n      .tox-label {\n        font-family: 'Roboto', sans-serif !important;\n      }\n      .tox-button--naked {\n        cursor: pointer;\n        &:hover:not(:disabled) {\n          background-color: transparent;\n        }\n      }\n      .tox-menu {\n        background-color: var(--inputs-filled-filled-surface) !important;\n      }\n      .tox-tbtn--select {\n        color: var(--inputs-default-icon);\n      }\n\n      .tox-dialog__title {\n        font-family: 'Roboto', sans-serif !important;\n      }\n      .tox-dialog {\n        border-radius: 0 !important;\n      }\n      .tox-dialog__header {\n        padding: 8px 16px 10px 16px;\n        &::before {\n          content: '';\n          width: 100%;\n          height: 1px;\n          background-color: #ececec;\n          position: absolute;\n          left: 0;\n          bottom: 0;\n        }\n        &:after {\n          content: '';\n          width: 42px;\n          height: 3px;\n          background-color: #fcc201;\n          position: absolute;\n          left: 0;\n          bottom: -1.5px;\n        }\n      }\n      .tox-dialog__footer {\n        padding: 16px;\n        .tox-button {\n          width: 100px;\n          border: none;\n          color: #ffffff !important;\n          background-color: #3c97aa !important;\n          font-family: 'Roboto', sans-serif !important;\n          border-radius: 0 !important;\n          font-weight: 400;\n          text-transform: uppercase;\n          cursor: pointer;\n        }\n        .tox-button[title]:hover:after {\n          content: attr(text);\n        }\n        .tox-button--secondary {\n          background-color: transparent !important;\n          color: #3c97aa !important;\n        }\n      }\n    }\n\n    .tox-textfield {\n      font-size: 12px;\n      line-height: 20px;\n      color: #000000;\n      font-family: 'Roboto', sans-serif !important;\n      outline: 0;\n    }\n    .tox .tox-custom-editor:focus-within,\n    .tox .tox-listboxfield .tox-listbox--select:focus,\n    .tox .tox-textarea-wrap:focus-within,\n    .tox .tox-textarea:focus,\n    .tox .tox-textfield:focus {\n      background-color: #fff !important;\n      border-color: #3c97aa !important;\n      box-shadow: none !important;\n    }\n\n    .tox .tox-dialog__body-nav-item--active {\n      border-bottom: 2px solid #3c97aa !important;\n      color: #3c97aa !important;\n    }\n\n    .tox-edit-area p img {\n      max-width: 200px !important;\n      width: 100% !important;\n      height: auto;\n    }\n\n    iframe img {\n      max-width: 200px !important;\n      width: 100% !important;\n      height: auto;\n    }\n\n    .tox-editor-header.tox-editor-header--empty {\n      display: none;\n    }\n\n    .tox .tox-tab {\n      display: none !important;\n    }\n\n    .tox.tox-tinymce {\n      border: 1px solid var(--inputs-filled-stroke);\n    }\n\n    .tox.tox-tinymce.tox-platform-touch {\n      -webkit-overflow-scrolling: touch !important;\n      overflow-y: scroll;\n    }\n  }\n}\n\n:global {\n  .tox.tox-tinymce-aux {\n    z-index: 1501;\n  }\n}\n\n.loaderWrapper {\n  position: absolute;\n  top: 40px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 5;\n  background-color: rgba(0, 0, 0, 0.15);\n}\n\n.loaderWrapperSimple {\n  top: 0;\n}\n\n.loader {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  & > img {\n    width: 50px;\n    height: 50px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editorWrapper": `editorWrapper__cQydx`,
	"simple": `simple__v6JnI`,
	"loaderWrapper": `loaderWrapper__R6kvI`,
	"loaderWrapperSimple": `loaderWrapperSimple__JnjwM`,
	"loader": `loader__CvX4Y`
};
module.exports = ___CSS_LOADER_EXPORT___;
